<template>
  <simple-section dark nopadding class="footer-section">
    <div>
      <a href="https://www.iubenda.com/privacy-policy/53720930"
        >Privacy Policy</a
      >
      &bull;
      <a href="mailto://contact@camoodoo.com">Contact</a>
    </div>

    <div>© 2018-2021 Steffen Conradt</div>
    <div>All rights reserved.</div>
    <div>
      Sony, Playmemories, NEX, RX and Alpha are trademarks of Sony Corporation.
    </div>
    <div>
      Canon, EOS are trademarks of Canon Corporation.
    </div>
    <div>
      Google Play and the Google Play logo are trademarks of Google LLC.
    </div>
  </simple-section>
</template>

<script>
import SimpleSection from "./SimpleSection.vue";
export default {
  components: { SimpleSection },
};
</script>

<style>
.footer-section {
  padding: 20pt;
  font-size: 66%;
  text-align: center;
}
</style>
